// Centralized content & constants for the EasyLister landing page

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_light-brand-pro/artifacts/mkb3yl0w_image%203.png";
export const ICON_URL =
  "https://customer-assets.emergentagent.com/job_3c9098ac-8831-4027-87d1-54f7344062d7/artifacts/xl2iicit_image%203.png";

export const CHROME_URL = "https://chromewebstore.google.com/detail/easylister/ehjfpifffjcdcaammjaichihpdgncoif";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Features", href: "#features" },
  { label: "Platforms", href: "#platforms" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQs", href: "#faq" },
];

export const HERO_STATS = [
  { value: "7+", label: "Tools in One Extension" },
  { value: "2", label: "Platforms Supported" },
  { value: "Free", label: "3-Day Trial to Start" },
  { value: "10x", label: "Faster Listings" },
  { value: "AI", label: "Powered Content" },
];

export const SIGNUP_BONUS = {
  badge: "Free Trial",
  title: "Start with a free 3-day trial — no card needed",
  sub: "Try AI listing, title optimise, and more. Upgrade anytime.",
};

export const MARQUEE_ITEMS = [
  "AI LISTING",
  "SEO KEYWORDS",
  "CLONE LISTING",
  "AUTO-FILL",
  "PRICE PANEL",
  "SHIPPING REDUCER",
  "SALES DASHBOARD",
  "COD & PREPAID ORDERS",
  "FLIPKART",
  "MEESHO",
  "FREE TRIAL",
  "10X FASTER",
];

export const PAINS = [
  "Type the same 50+ fields for every new listing",
  "Write product descriptions from scratch every time",
  "Guess which keywords will rank on Flipkart/Meesho",
  "Open each catalog one by one just to change a price",
  "Navigate 4 pages to see today's orders and revenue",
  "Lose ₹15–₹35 per order to avoidable shipping charges",
  "No idea whether today's orders are COD or Prepaid",
];

export const GAINS = [
  "Clone any listing — form fills in seconds",
  "AI writes your title, description & attributes instantly",
  "Top SEO keywords auto-suggested for your category",
  "Bulk-update all catalog prices from one panel",
  "Live sales dashboard: revenue, orders, COD/Prepaid at a glance",
  "Shipping reducer finds the cheapest label automatically",
  "COD vs Prepaid breakdown updated throughout the day",
];

export const FEATURES = [
  {
    id: "clone",
    icon: "Copy",
    badge: "Bestseller",
    access: "paid",
    title: "Listing Clone",
    desc: "Browse any product on any e-commerce platform, click Clone in the Easy Lister toolbar, then open your Flipkart or Meesho seller panel and hit Auto Fill — the form fills itself completely. No typing needed.",
    points: [
      "Step 1: Clone from any e-commerce product page",
      "Step 2: Auto Fill on the Flipkart or Meesho seller panel form",
      "Auto-fills: Title, Description, Category, HSN, Weight, Dimensions",
      "Works across all major categories",
      "Each Auto Fill uses 1 ELT credit",
    ],
  },
  {
    id: "autofill",
    icon: "Zap",
    access: "paid",
    title: "Auto-Fill Seller Form",
    desc: "Listing a brand-new product? Just open the seller form — Easy Lister fills every field in one click. No manual typing, no missed mandatory fields.",
    points: [
      "One-click fill for both Flipkart and Meesho forms",
      "Handles multi-variant products (size, color, material)",
      "Fills all mandatory and optional attributes",
      "Prevents common errors from manual data entry",
      "Each Auto Fill uses 1 ELT credit",
    ],
  },
  {
    id: "ai",
    icon: "Sparkles",
    badge: "New",
    access: "paid",
    title: "AI-Powered Listing Content",
    desc: "Stop staring at a blank description box. Built-in AI generates complete, conversion-optimized product titles, descriptions, and attributes — in seconds.",
    points: [
      "AI writes the full title, description, and key features",
      "Tailored to category and target buyer on each platform",
      "Avoids banned words; follows platform guidelines",
      "Supports regional products and Indian market language",
      "Use your 10 free signup credits to try it instantly",
    ],
  },
  {
    id: "seo",
    icon: "Search",
    badge: "New",
    access: "free",
    title: "Top SEO Keywords",
    desc: "Listing with the right keywords means more organic visibility. Easy Lister surfaces top-performing keywords for your category so you don't have to guess.",
    points: [
      "Auto-suggests top search keywords for your niche",
      "Shows search volume and relevance score per keyword",
      "Insert into your title and description with one click",
      "Separate keyword sets for Flipkart and Meesho algorithms",
      "Updated regularly based on platform search trends",
    ],
  },
  {
    id: "price",
    icon: "Tag",
    access: "paid",
    title: "Meesho Price Update Panel",
    desc: "Managing prices on Meesho is painful. The Easy Lister price panel shows all your catalogs in one sidebar and lets you update prices instantly.",
    points: [
      "View all your Meesho catalogs in one control panel",
      "Edit any variant price directly from the panel",
      "Bulk-update multiple catalogs at once",
      "Works on Active, Out-of-Stock, and Paused catalogs",
      "Use your 10 free signup credits to try it instantly",
    ],
  },
  {
    id: "shipping",
    icon: "PackageCheck",
    badge: "Save Money",
    access: "free",
    title: "Meesho Shipping Reducer",
    desc: "Meesho calculates shipping based on your product image. Easy Lister tests image variants and locks in the cheapest shipping rate automatically.",
    points: [
      "Detects the image that triggers the lowest shipping category",
      "Tests multiple image versions automatically",
      "Saves ₹15–₹35 per order on average",
      "On 100 monthly orders that's ₹1,500–₹3,500 saved",
      "Works on new listings and existing ones",
    ],
  },
  {
    id: "dashboard",
    icon: "LayoutDashboard",
    badge: "New",
    access: "limited",
    title: "Daily Sales Dashboard",
    desc: "Sync your seller panel data in one click — Easy Lister pulls your latest orders and generates a clean daily report instantly. No manual downloads, no page-hopping. Just hit Sync and see today's full picture.",
    points: [
      "One-tap Sync from the seller panel — fresh report instantly",
      "Today's total orders — at a glance",
      "Revenue breakdown for the day",
      "COD vs Prepaid Orders — separate counts",
      "Basic sync is free · Full report uses ELT credits",
    ],
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Install the Extension",
    desc: "Add Easy Lister from the Chrome Web Store. 30 seconds, no sign-up required.",
  },
  {
    n: "02",
    title: "Open Your Seller Panel",
    desc: "Go to Flipkart Seller Hub or Meesho Supplier Panel. The Easy Lister toolbar activates automatically.",
  },
  {
    n: "03",
    title: "List, Price, Track & Sell",
    desc: "Use any of the 7 tools — clone, AI fill, SEO boost, price update, shipping reducer, or sales dashboard.",
  },
];

export const PLATFORMS = [
  {
    name: "Flipkart Seller Hub",
    accent: "from-amber-100 to-orange-50",
    dot: "bg-orange-500",
    features: [
      "Clone existing listings",
      "Auto-fill new product forms",
      "AI-generated listing content",
      "SEO keyword suggestions",
      "All major categories supported",
    ],
  },
  {
    name: "Meesho Supplier Panel",
    accent: "from-purple-100 to-fuchsia-50",
    dot: "bg-purple-600",
    features: [
      "Clone existing listings",
      "Auto-fill new product forms",
      "AI-generated listing content",
      "SEO keyword suggestions",
      "Price update panel (bulk edit)",
      "Shipping charges reducer",
      "Daily sales dashboard (COD + Prepaid)",
    ],
  },
];

export const SEO_KEYWORDS_EXAMPLE = [
  { kw: "kurti for women", vol: "High" },
  { kw: "cotton kurti", vol: "High" },
  { kw: "printed kurti set", vol: "High" },
  { kw: "straight kurti below knee", vol: "Medium" },
  { kw: "kurti with pant", vol: "High" },
  { kw: "A-line kurti", vol: "Medium" },
  { kw: "casual kurti daily wear", vol: "Medium" },
  { kw: "kurti under 500", vol: "High" },
];

export const TRUST_POINTS = [
  { icon: "Bot", title: "AI-Powered", desc: "Generate complete listings in one click. No writing skills needed." },
  { icon: "Search", title: "SEO Built-In", desc: "Rank higher on Flipkart & Meesho with the right keywords, automatically." },
  { icon: "PiggyBank", title: "Saves Real Money", desc: "Shipping reducer and bulk pricing save thousands per month." },
  { icon: "LayoutDashboard", title: "Smart Dashboard", desc: "COD, Prepaid, Revenue, Returns — all in one glance." },
  { icon: "Zap", title: "Lightning Fast", desc: "Fill a complete form in under 10 seconds." },
  { icon: "Gift", title: "Free Trial", desc: "Start with a free 3-day trial — no card needed. Upgrade to a paid plan anytime." },
  { icon: "ShieldCheck", title: "Private & Safe", desc: "Everything runs in your browser. We never see your data." },
  { icon: "RefreshCw", title: "Always Updated", desc: "Extension stays in sync with Flipkart & Meesho UI changes." },
];

export const TESTIMONIALS = [
  {
    quote:
      "The AI listing feature is incredible. I listed 50 products in one afternoon. Earlier that would take me 3 days.",
    name: "Riya Shah",
    role: "Meesho Seller, Surat",
    avatar:
      "https://images.unsplash.com/photo-1542190891-2093d38760f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTcwNzI3N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "SEO keywords actually work. My Flipkart views doubled in 2 weeks after I started using the keyword tool.",
    name: "Amit Patel",
    role: "Flipkart Seller, Ahmedabad",
    avatar:
      "https://images.unsplash.com/photo-1762341124796-530c0085f7d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTcwNzI3N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "The sales dashboard is what I didn't know I needed. COD vs prepaid at a glance every morning — love it.",
    name: "Priya Menon",
    role: "Meesho Seller, Bengaluru",
    avatar:
      "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTcwNzI3N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Is there a free trial?",
    a: "Yes! Every new account gets a free 3-day Trial plan — no card required. You get limited AI listing, title optimise, description + SEO, and XLSX export uses per day. Upgrade anytime to a paid plan.",
  },
  {
    q: "How do the subscription plans work?",
    a: "EasyLister uses monthly subscriptions: Trial (free, 3 days), Starter (₹149/month), Growth (₹399/month), or Pro (₹799/month). Each plan gives you a daily allowance of AI-powered features plus unlimited access to Labels, Inventory scan, and Auto-fill scan. Daily limits reset at midnight IST.",
  },
  {
    q: "What counts toward my daily limit?",
    a: "AI listing generations, title optimisations, description + SEO generations, and XLSX exports each count toward their own daily limit. The limits reset at midnight IST every day. Free features like Labels, Inventory scan, and Auto-fill scan have no limits on any plan.",
  },
  {
    q: "What is Enhancement AI and which plan includes it?",
    a: "Enhancement AI is an advanced AI feature that refines and improves your existing product content for better discoverability and conversions. It is available exclusively on the Pro plan (₹799/month).",
  },
  {
    q: "How does device limit work?",
    a: "Each plan allows a set number of simultaneous active devices. Trial allows 1 device (a 2nd login instantly logs out the 1st). Starter allows 2 devices. Growth allows 3 devices. Pro has no device limit. When the limit is exceeded on Starter/Growth, the oldest session is automatically logged out.",
  },
  {
    q: "Can I upgrade or change my plan anytime?",
    a: "Yes. You can upgrade or switch plans at any time from your Subscription page in the app. The new plan takes effect immediately.",
  },
  {
    q: "Does it work on both Flipkart and Meesho?",
    a: "Yes. Easy Lister supports Flipkart Seller Hub and Meesho Supplier Panel. Install once — it activates automatically on both platforms.",
  },
  {
    q: "How does the AI listing feature work?",
    a: "Easy Lister reads your product name and category, then uses AI to generate a complete title, description, key features, and attributes in seconds. You review, edit if needed, and insert into the form with one click. Each generation counts as 1 daily AI listing use.",
  },
  {
    q: "How does the Meesho Shipping Reducer work?",
    a: "Meesho calculates shipping based on your product image. Easy Lister tests multiple image variants and identifies the one that triggers the lowest shipping slab — saving you ₹15–₹35 per order. This feature is completely free on all plans.",
  },
  {
    q: "Will it get my seller account banned?",
    a: "No. Easy Lister only reads and fills visible form fields in your browser, exactly as you would manually. It does not use bots or access any private APIs. It complies fully with platform terms.",
  },
  {
    q: "Which browsers are supported?",
    a: "Google Chrome currently. Support for Edge and Brave (Chromium-based) is planned.",
  },
  {
    q: "How do I get support?",
    a: "Email us at support@easylister.co.in. We typically reply within 24 hours.",
  },
];

export const PRICING_PLANS = [
  {
    id: "trial",
    name: "Trial",
    icon: "Sparkles",
    price: "₹25",
    credits: 5,
    perCredit: "₹5.00",
    savings: null,
    support: "Standard support",
    cta: "Buy Trial Pack",
    popular: false,
  },
  {
    id: "starter",
    name: "Starter",
    icon: "Zap",
    price: "₹109",
    credits: 25,
    perCredit: "₹4.36",
    savings: "Save 12.8%",
    support: "Email support",
    cta: "Buy Starter Pack",
    popular: false,
  },
  {
    id: "pro",
    name: "Pro",
    icon: "Crown",
    price: "₹399",
    credits: 100,
    perCredit: "₹3.99",
    savings: "Save 20.2%",
    support: "Priority support",
    cta: "Buy Pro Pack",
    popular: true,
  },
  {
    id: "business",
    name: "Business",
    icon: "Building2",
    price: "₹1,799",
    credits: 500,
    perCredit: "₹3.60",
    savings: "Save 28%",
    support: "Dedicated support",
    cta: "Buy Business Pack",
    popular: false,
  },
];

export const PRICING_INCLUSIONS = [
  "1 credit per Auto Fill",
  "All listing platforms (Flipkart & Meesho)",
  "Credits never expire",
];

export const CREDIT_USAGE = [
  {
    icon: "Zap",
    title: "Auto Fill Form",
    cost: "1 ELT",
    free: false,
    desc: "Create listings faster by automatically filling marketplace forms with your saved product data.",
  },
  {
    icon: "BarChart3",
    title: "Price Manager Export",
    cost: "2 ELT",
    free: false,
    desc: "Export and manage pricing information in bulk with marketplace-compatible files.",
  },
  {
    icon: "Sparkles",
    title: "Product AI Improvement",
    cost: "4 ELT",
    free: false,
    desc: "Leverage AI to refine product content, improve discoverability, and boost conversion potential.",
  },
  {
    icon: "Tag",
    title: "Price Reducer",
    cost: "FREE",
    free: true,
    desc: "Easily apply discounts and optimize pricing strategies without consuming ELT.",
  },
];

export const FOOTER_FEATURES = [
  "Listing Clone",
  "Auto-Fill Forms",
  "AI Listing Content",
  "SEO Keywords",
  "Price Update Panel",
  "Shipping Reducer",
  "Sales Dashboard",
];
